module.exports = __webpack_public_path__ + "img/motiplate-banner.4fbb9185.png";